import React, { useRef } from 'react';
import styles from './VideoSection.module.css';
import { PlayCircleOutline } from '@mui/icons-material';
import { gaEvent } from '../../../../utils/analytics';

// Render do projeto de vídeo (video/, composição ApresentacaoV2)
const VIDEO_SRC = '/assets/landing/gabriela-apresentacao.mp4';
const VIDEO_POSTER = '/assets/landing/gabriela-apresentacao.jpg';

function VideoSection() {
  const playTracked = useRef(false);

  const handlePlay = () => {
    if (playTracked.current) return;
    playTracked.current = true;
    gaEvent('lp_video_play', { placement: 'video_section' });
  };

  return (
    <section id="video" className={styles.videoSection}>
      <div className={styles.sectionContainer}>
        <div className={styles.badge}>
          <PlayCircleOutline className={styles.badgeIcon} />
          <span>Veja na prática</span>
        </div>

        <h2 className={styles.sectionTitle}>Conheça a Gabriela em menos de um minuto</h2>
        <p className={styles.sectionSubtitle}>
          Agenda, pacientes, documentos, financeiro e comunicação trabalhando juntos na rotina da sua clínica.
        </p>

        <div className={styles.videoFrame}>
          <video
            className={styles.video}
            src={VIDEO_SRC}
            poster={VIDEO_POSTER}
            controls
            playsInline
            preload="none"
            onPlay={handlePlay}
          />
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
